import React from 'react';
import { useSelector } from 'react-redux';
import { LinkButton, Typography } from 'fronton-react';
import { ChevronRightIcon } from '@fronton/icons-react';
import { selectIsMobileView } from 'selectors';
import { pravilaUslugInfoBar, StyledUl, linkButtonStyles } from './styles';
import NAVBAR_LINKS from '../../navbar-links.json';
import { LinkProps } from '../types';
import { MOBILE_VIEW_SEARCH_PARAM } from '../../../../constants';

const LinkItem = ({ label, link }: LinkProps) => (
	<li>
		<LinkButton
			href={link}
			iconLeft={<ChevronRightIcon type="outline" size="m" />}
			className={linkButtonStyles}
		>
			<Typography variant="m" size="body_long">
				{label}
			</Typography>
		</LinkButton>
	</li>
);

export const PravilaUslug = () => {
	const isMobileView = useSelector(selectIsMobileView);

	return (
		<div data-qa={'rules-pravilaUslug'}>
			<div className={pravilaUslugInfoBar}>
				<Typography variant="s" size="body_long" as="p" color="text-primary">
					Вы можете заказать услуги по ремонту и обустройству Вашего дома в Лемана ПРО. На
					этих страницах вы можете ознакомиться с правилами оказания услуг
				</Typography>
			</div>
			<StyledUl>
				{NAVBAR_LINKS.map(
					({ link, label }, idx) =>
						idx > 1 && (
							<LinkItem
								label={label}
								link={link + (isMobileView ? `?${MOBILE_VIEW_SEARCH_PARAM}` : '')}
								key={label}
							/>
						)
				)}
			</StyledUl>
		</div>
	);
};
